'use client';

import { useLayoutEffect } from 'react';

/**
 * Marks the rendered `[data-block-id]` host as draft-hidden for studio preview
 * mute styles. Used because PreviewCanvas does not mount SitePage.
 */
export function BlockHiddenMarker({ blockId, hidden }: { blockId: string; hidden: boolean }) {
  useLayoutEffect(() => {
    const el = document.querySelector<HTMLElement>(
      `[data-block-id="${CSS.escape(blockId)}"]`,
    );
    if (!el) {
      return;
    }
    if (hidden) {
      el.setAttribute('data-block-hidden', 'true');
      el.classList.add('ws-block--hidden');
    } else {
      el.removeAttribute('data-block-hidden');
      el.classList.remove('ws-block--hidden');
    }
    return () => {
      el.removeAttribute('data-block-hidden');
      el.classList.remove('ws-block--hidden');
    };
  }, [blockId, hidden]);

  return null;
}
